@for (item of toast.items(); track item.id) {
	<div
		class="toast-container"
		animate.enter="toast-enter-animation"
		animate.leave="toast-leave-animation"
	>
		<vis-toast-item
			[title]="item.title"
			[message]="item.message"
			[level]="item.level"
			[duration]="item.duration"
			(click)="toast.remove(item.id)"
			(timeIsUp)="toast.remove(item.id)"
		></vis-toast-item>
	</div>
}
